var settingsMenu = {};
var themes = {};
var themeLoader = {};

themeLoader.load = function(init) {

  if (init && !localStorage.selectedTheme) {
    return;
  }

  var body = document.getElementsByTagName('body')[0];

  // Class-preserving theme stamp (2026-08-30, mirrors themeLoader.js): wholesale
  // `body.className = 'theme_X'` wiped every other class on <body> — it deleted
  // staffMode (staffModeEarly.js) and caused the post-paint staff nav swap.
  function stampBodyTheme(themeId) {
    var cls = body.className.split(/\s+/).filter(function (c) {
      return c && c.indexOf('theme_') !== 0;
    });
    cls.push('theme_' + themeId);
    body.className = cls.join(' ');
  }

  // Mirror themeLoader.js: theme wrappers are dual-scoped ("html.theme_X, .theme_X")
  // and the FOUC head script only stamps <html> at page load, so a runtime switch
  // must re-stamp <html> too (or the old theme's html.* rules keep matching) and
  // clear the head script's inline background (inline styles beat all CSS).
  var html = document.documentElement;

  if (localStorage.selectedTheme) {
    if (themeLoader.customCss && themeLoader.customCss.parentNode) {
      themeLoader.customCss.remove();
    }
    stampBodyTheme(localStorage.selectedTheme);
    html.className = 'theme_' + localStorage.selectedTheme;
  } else {
    if (themeLoader.customCss && !themeLoader.customCss.parentNode) {
      document.head.appendChild(themeLoader.customCss);
    }
    // "Default" = the engine's baked defaultTheme. It is gitgud — the SAME fallback
    // the FOUC inline script in base.njk uses (`selectedTheme || 'gitgud'`). Do NOT
    // read localStorage.defaultTheme here: that key actually holds whatever theme was
    // ACTIVE at last load ("lastActiveTheme"), so restoring from it re-applied the
    // current non-default theme on a "Default" selection and only fixed itself on
    // reload. Hardcoding the real default makes a runtime switch to Default identical
    // to a fresh page load in every case.
    var def = 'gitgud';
    stampBodyTheme(def);
    html.className = 'theme_' + def;
  }

  if (!init) {
    html.style.removeProperty('background');
  }

};

var linkedCss = document.getElementsByTagName('link');

for (var i = 0; i < linkedCss.length; i++) {

  var ending = '/custom.css';

  if (linkedCss[i].href.indexOf(ending) === linkedCss[i].href.length
      - ending.length) {
    themeLoader.customCss = linkedCss[i];
    break;
  }
}

themeLoader.load(true);

settingsMenu.init = function() {

  settingsMenu.loadedFilters = JSON.parse(localStorage.filterData || '[]');

  settingsMenu.filterTypes = [ 'Name', 'Tripcode', lang.subject, lang.message, 'Id' ];

  var settingsMenuDiv = document.createElement('div');

  settingsMenu.placeNavBarButton(settingsMenuDiv);

  var settingsMenuHeader = document.createElement('div');
  settingsMenuHeader.className = 'header';
  settingsMenuDiv.appendChild(settingsMenuHeader);

  // Title of the settings panel — a plain element, NOT a <label>: there is no form
  // control to label, and an orphaned <label> trips Chrome's a11y audit. A <div> is
  // safe here (flex item in .header; all styling is class-based .headerLabel).
  var settingsMenuLabel = document.createElement('div');
  settingsMenuLabel.innerHTML = lang.settings;
  settingsMenuLabel.className = 'headerLabel';

  settingsMenuHeader.appendChild(settingsMenuLabel);

  settingsMenu.showingSettings = false;

  // Close API (mutual exclusion, operator 2026-08-30): navBurger.js / watcher.js
  // call this when THEY open so only one of boards-burger / watched-list /
  // settings is ever rendered; the close-X and the settings-button re-click
  // toggle route through it too.
  settingsMenu.close = function() {
    if (!settingsMenu.showingSettings) {
      return;
    }
    settingsMenu.showingSettings = false;
    settingsMenuDiv.classList.add('closed');
  };

  var closeSettingsMenuButton = document.createElement('span');
  closeSettingsMenuButton.id = 'closeSettingsMenuButton';
  closeSettingsMenuButton.onclick = function() {
    settingsMenu.close();
  };

  settingsMenuHeader.appendChild(closeSettingsMenuButton);

  settingsMenuDiv.appendChild(document.createElement('hr'));

  settingsMenuDiv.id = 'settingsMenu';
  settingsMenuDiv.className = 'floatingMenu closed';

  document.body.appendChild(settingsMenuDiv);

  draggable.setDraggable(settingsMenuDiv, settingsMenuHeader);

  settingsMenu.tabsDiv = document.createElement('div');
  settingsMenu.tabsDiv.className = 'settingsTabs';
  settingsMenuDiv.appendChild(settingsMenu.tabsDiv);

  settingsMenu.menuContentPanel = document.createElement('div');
  settingsMenu.menuContentPanel.id = 'menuContentPanel';
  settingsMenuDiv.appendChild(settingsMenu.menuContentPanel);

  settingsMenu.sfw();
  settingsMenu.postCounter();
  settingsMenu.verboseDate();

  settingsMenu.registerTab(lang.mainSettings, settingsMenu.getMainContent(), true);
  settingsMenu.registerTab(lang.filter, settingsMenu.getFiltersContent());
  settingsMenu.registerTab(lang.themes, settingsMenu.getCSSSelectorContent());
  settingsMenu.registerTab(lang.css, settingsMenu.getCSSContent());

};

settingsMenu.selectSettingsPanel = function(tab, panel) {

  if (tab === settingsMenu.currentSettingsTab) {
    return;
  }

  if (settingsMenu.currentSettingsTab) {
    settingsMenu.currentSettingsTab.id = '';
    settingsMenu.currentSettingsPanel.remove();
  }

  settingsMenu.menuContentPanel.appendChild(panel);
  tab.id = 'selectedTab';

  settingsMenu.currentSettingsPanel = panel;
  settingsMenu.currentSettingsTab = tab;

};

settingsMenu.registerTab = function(text, content, select) {

  var newTab = document.createElement('span');
  newTab.innerHTML = text;
  newTab.className = 'settingsTab';
  newTab.onclick = function() {
    settingsMenu.selectSettingsPanel(newTab, content);
  };
  settingsMenu.tabsDiv.appendChild(newTab);

  if (select) {
    newTab.onclick();
  }

};

settingsMenu.placeNavBarButton = function(settingsMenuDiv) {

  var settingsButton = document.getElementById('settingsButton');

  if (!settingsButton) {
    return;
  }

  // The "Settings" label + ' / ' divider are STATIC markup (rightBar*.njk)
  // since 2026-08-30 — they used to be injected HERE after first paint, growing
  // the nav's right side on every load. Wire only.
  settingsButton.onclick = function() {

    if (settingsMenu.showingSettings) {
      settingsMenu.close();   // re-click toggles closed (operator 2026-08-30)
      return;
    }

    // Mutual exclusion FIRST (operator 2026-08-30): only one of boards-burger /
    // watched-list / settings may be open. The other menus' outside-click
    // closers never fire for us, so signal each explicitly.
    document.querySelectorAll('#topNav.open, #bottomNav.open').forEach(function (n) {
      n.classList.remove('open');
    });
    document.dispatchEvent(new CustomEvent('watcher-close'));
    document.dispatchEvent(new CustomEvent('staffnav-close'));

    // Render BELOW the icon row, not over it (2026-08-30): the gear must stay
    // visible so re-tap closes the sheet — same idiom as #watchedMenu /
    // .staffNavPanel. Measured after the cross-closes above so #topNav is
    // just the row (an open burger panel would inflate it).
    if (window.matchMedia('(max-width: 479px)').matches) {
      var topNav = document.getElementById('topNav');
      settingsMenuDiv.style.top = (topNav ? topNav.offsetHeight : 0) + 'px';
    } else {
      settingsMenuDiv.style.top = '';   /* clear a stale mobile inline on resize */
    }

    settingsMenu.showingSettings = true;
    settingsMenuDiv.classList.remove('closed');

  }

};

settingsMenu.addFilterDisplay = function(filter) {

  var filterCell = document.createElement('div');

  var cellWrapper = document.createElement('div');
  settingsMenu.existingFiltersDiv.appendChild(cellWrapper);

  var filterTypeLabel = document.createElement('span');
  filterTypeLabel.innerHTML = settingsMenu.filterTypes[filter.type];
  filterTypeLabel.className = 'existingFilterTypeLabel';
  filterCell.appendChild(filterTypeLabel);

  var filterContentLabel = document.createElement('span');
  var contentToDisplay = filter.filter;
  if (filter.regex) {
    contentToDisplay = '/' + contentToDisplay + '/';
  }
  filterContentLabel.textContent = contentToDisplay;
  filterContentLabel.className = 'existingFilterContentLabel';
  filterCell.appendChild(filterContentLabel);

  var button = document.createElement('span');
  button.className = 'filterDeleteButton';
  filterCell.appendChild(button);

  button.onclick = function() {

    settingsMenu.loadedFilters.splice(settingsMenu.loadedFilters
        .indexOf(filter), 1);

    localStorage.filterData = JSON.stringify(settingsMenu.loadedFilters);

    hiding.checkFilters();

    cellWrapper.remove();

  };

  cellWrapper.appendChild(document.createElement('hr'));
  cellWrapper.appendChild(filterCell);

};

settingsMenu.createFilter = function(content, regex, type) {

  var newFilterData = {
    filter : content,
    regex : regex,
    type : type
  };

  settingsMenu.addFilterDisplay(newFilterData);

  settingsMenu.loadedFilters.push(newFilterData);

  localStorage
      .setItem('filterData', JSON.stringify(settingsMenu.loadedFilters));

  hiding.checkFilters();

};

settingsMenu.getFiltersContent = function() {

  var filtersPanel = document.createElement('div');

  var newFilterPanel = document.createElement('span');
  newFilterPanel.id = 'newFilterPanel';

  filtersPanel.appendChild(newFilterPanel);

  var newFilterTypeCombo = document.createElement('select');

  for (var i = 0; i < 4; i++) {

    var option = document.createElement('option');
    option.innerHTML = settingsMenu.filterTypes[i];
    newFilterTypeCombo.appendChild(option);
  }

  newFilterPanel.appendChild(newFilterTypeCombo);

  var newFilterField = document.createElement('input');
  newFilterField.type = 'text';
  newFilterField.placeholder = lang.placeHolderFilter;
  newFilterPanel.appendChild(newFilterField);

  var regexLabel = document.createElement('label');
  regexLabel.innerHTML = 'Regex';
  regexLabel.className = 'settingsLabel';
  newFilterPanel.appendChild(regexLabel);

  var newFilterRegex = document.createElement('input');
  newFilterRegex.type = 'checkbox';
  regexLabel.className = 'settingsCheckbox';
  newFilterPanel.appendChild(newFilterRegex);

  var newFilterButton = document.createElement('button');
  newFilterButton.innerHTML = lang.addFilter;
  newFilterButton.onclick = function() {

    var filterContent = newFilterField.value.trim();

    if (!filterContent) {
      return;
    }

    settingsMenu.createFilter(filterContent, newFilterRegex.checked,
        newFilterTypeCombo.selectedIndex);

  };
  newFilterPanel.appendChild(newFilterButton);

  var existingFiltersLabelsPanel = document.createElement('div');
  filtersPanel.appendChild(existingFiltersLabelsPanel);

  var labelType = document.createElement('label');
  labelType.innerHTML = lang.type;
  labelType.id = 'labelExistingFilfterType';
  existingFiltersLabelsPanel.appendChild(labelType);

  var labelContent = document.createElement('label');
  labelContent.innerHTML = lang.content;
  labelContent.id = 'labelExistingFilfterContent';
  existingFiltersLabelsPanel.appendChild(labelContent);

  settingsMenu.existingFiltersDiv = document.createElement('div');
  settingsMenu.existingFiltersDiv.id = 'existingFiltersPanel';
  filtersPanel.appendChild(settingsMenu.existingFiltersDiv);

  for (var i = 0; i < settingsMenu.loadedFilters.length; i++) {
    settingsMenu.addFilterDisplay(settingsMenu.loadedFilters[i]);
  }

  return filtersPanel;

};

settingsMenu.sfw = function() {

  if (settings.get('sfwMode')) {
    document.body.className += ' ' + 'sfw';
  }

};

settingsMenu.postCounter = function() {

  if (settings.get('postCounter')) {
    document.body.className += ' ' + 'postCounter';
  }

};

/* v6 mobile post line: body.verboseDate drives the "date on its own line"
   CSS (_posting.scss) and the verbose render branch in postDate.js.
   Same init-time stamper shape as sfw()/postCounter() — toggling in the menu
   persists (save iterates all settings.modes keys) and applies on next load. */
settingsMenu.verboseDate = function() {

  if (settings.get('verboseDate')) {
    document.body.className += ' verboseDate';
  }

};

settingsMenu.getCSSContent = function() {

  var savedCSS = localStorage.customCSS;

  var head = document.getElementsByTagName('head')[0];

  var newCSS = document.createElement('style');

  head.appendChild(newCSS);

  if (savedCSS) {
    newCSS.innerHTML = savedCSS;
  }

  var cssPanel = document.createElement('div');

  var cssArea = document.createElement('textarea');
  cssPanel.appendChild(cssArea);
  if (savedCSS) {
    cssArea.value = savedCSS;
  }
  cssArea.id = 'cssInput';

  var bottomDiv = document.createElement('div');
  cssPanel.appendChild(bottomDiv);

  var saveButton = document.createElement('button');
  saveButton.className = 'saveButton';
  saveButton.innerHTML = lang.save;
  bottomDiv.appendChild(saveButton);

  saveButton.onclick = function() {
    newCSS.innerHTML = cssArea.value.trim();
    localStorage.customCSS = newCSS.innerHTML;
  };

  return cssPanel;

};

settingsMenu.getCSSSelectorContent = function() {

  /* Clear (id 'clear') was the "no CSS" option; removed 2026-08-17 because the
     base layer now carries the dark-plum default (post-form card), so it would
     be a redundant copy of Default. Old localStorage users keep getting the
     pure-base look harmlessly (theme_clear matches no CSS). */
  themes.themes = [ {
    label : 'Dark Reader',
    id : 'darkreader'
  }, {
    label : 'Tomorrow (Night)',
    id : 'tomorrow'
  }, {
    label : 'Green',
    id : 'green'
  }, {
    label : 'Yotsuba B',
    id : 'yotsubaB'
  }, {
    label : 'Catppuccin Mocha',
    id : 'catppuccin'
  } ];

    var cssPanel = document.createElement('div');

    var themeSelector = document.createElement('select');
    cssPanel.appendChild(themeSelector);

    themeSelector.id = 'themeSelector';

    var vanillaOption = document.createElement('option');
    vanillaOption.innerHTML = 'Default';
    themeSelector.appendChild(vanillaOption);

    for (var i = 0; i < themes.themes.length; i++) {

      var theme = themes.themes[i];

      var themeOption = document.createElement('option');
      themeOption.innerHTML = theme.label;

      if (theme.id === localStorage.selectedTheme) {
        themeOption.selected = true;
      }

      themeSelector.appendChild(themeOption);

    }

    themeSelector.onchange = function() {

      if (!themeSelector.selectedIndex) {

        if (localStorage.selectedTheme) {
          delete localStorage.selectedTheme;
          themeLoader.load();
        }

        return;
      }

      var selectedTheme = themes.themes[themeSelector.selectedIndex - 1];

      if (selectedTheme.id === localStorage.selectedTheme) {
        return;
      }

      localStorage.selectedTheme = selectedTheme.id;

      themeLoader.load();

    };

  var bottomDiv = document.createElement('div');
  cssPanel.appendChild(bottomDiv);

  return cssPanel;

};

/* ============================================================
   Main tab layout (2026-08-17)
   The old tab was one flat alphabetical-ish dump of every option.
   Now it is grouped by purpose and ordered by how often a visitor
   touches each thing: Display, Browsing, Posting, Audio & media,
   then Advanced for the power-user/legacy toggles. Keys and
   defaults still live in settings.modes (settings.js) — this is
   presentation only. `desc` gives one plain-English line to the
   options that don't explain themselves.
   ============================================================ */
settingsMenu.sections = [ {
  title : 'Display',
  keys : [ { key : 'relativeTime', desc : 'Show "5 minutes ago" alongside exact timestamps.' }, {
    key : 'verboseDate',
    desc : 'Mobile: full post date with weekday on its own line, plus a relative hint for recent posts.'
  }, {
    key : 'convertLocalTimes',
    desc : 'Show post times in your local timezone.'
  }, {
    key : 'sfwMode',
    desc : 'Hide images until you hover over them.'
  }, {
    key : 'showYous',
    desc : 'Mark your own posts with "(You)" in threads.'
  }, { key : 'postCounter', desc : 'Show each post\'s number within a thread.' }, {
    key : 'autoMarkAsDeleted',
    desc : 'Automatically show a marker where a post was deleted.'
  } ]
}, {
  title : 'Browsing',
  keys : [ { key : 'autoRefreshMode', desc : 'Reload the thread automatically when new posts arrive.' }, {
    key : 'previewOnHover'
  }, {
    key : 'previewOnHoverSound',
    desc : 'Play a sound when a hover preview appears.'
  }, { key : 'scrollDownMode' } ]
}, {
  title : 'Posting',
  keys : [ { key : 'qrMode', desc : 'Floating quick-reply box on thread pages.' }, {
    key : 'scrollPostFormMode'
  }, {
    key : 'compressClipboardImages',
    desc : 'Re-compress images pasted from the clipboard before upload.'
  } ]
}, {
  title : 'Audio & media',
  keys : [ { key : 'audioThread', desc : 'Treat a thread\'s audio posts as a playable playlist.' }, {
    key : 'audioThreadAutoPlay'
  }, {
    key : 'audioThreadNavPlayer',
    desc : 'Put the playlist player in the top bar instead of the bottom.'
  }, { key : 'autoPlayAnimations', desc : 'Autoplay animated images (GIFs).' } ]
}, {
  title : 'Advanced',
  keys : [ { key : 'editInOekaki', desc : 'Open pasted images in the built-in canvas editor before posting.' }, {
    key : 'mediaHiding',
    desc : 'Allow hiding individual media attachments on a thread.'
  }, {
    key : 'ensureBypass',
    desc : 'Always pre-select the captcha bypass when posting.'
  }, { key : 'noWs', desc : 'Use polling instead of websockets for thread updates.' }, {
    key : 'showHiddenPosts',
    desc : 'Also show posts that are excluded from regular viewers.',
    staffOnly : true
  } ]
} ];

settingsMenu.getMainContent = function() {

  var mainPanel = document.createElement('div');
  mainPanel.className = "mainPanel";

  var mainPanelSubContainer = document.createElement('div');
  mainPanelSubContainer.className = "mainPanelSubContainer";

  for (var s = 0; s < settingsMenu.sections.length; s++) {

    var section = settingsMenu.sections[s];

    var secDiv = document.createElement('div');
    secDiv.className = 'settingsSection';

    var heading = document.createElement('div');
    heading.className = 'settingsSectionTitle';
    heading.textContent = section.title;
    /* All sections start collapsed on every device (operator 2026-08-17): the
       mobile sheet is small so categories pre-collapse and expand on tap, and
       desktop now matches that instead of opening as one long flat list.
       The title toggles on any device.
       ⚠ secDiv/heading are `var` (function-scoped) — the handler MUST capture
       THIS iteration's div via an IIFE, or every title toggles the LAST section
       (bitten 2026-08-17: all clicks opened "Advanced" on mobile, appeared dead
       on desktop). */
    secDiv.classList.add('collapsed');
    (function(div) {
      heading.onclick = function() {
        // Accordion on EVERY device (operator 2026-10-18, extends the mobile
        // rule from 2026-08-30): expanding one section collapses the others.
        // With every category expanded the panel outgrew its height and
        // scrolling was ambiguous (page-behind vs sheet) and the bottom
        // buttons rendered offscreen — desktop included. One-open-at-a-time
        // keeps it short enough not to need the internal scroll at all.
        if (div.classList.contains('collapsed')) {
          // mainPanelSubContainer is the in-scope holder of all sections
          // (settingsMenuDiv is LOCAL to init() — referencing it here throws
          // a ReferenceError and kills the toggle, 2026-08-30 regression).
          mainPanelSubContainer.querySelectorAll('.settingsSection').forEach(function (other) {
            other.classList.add('collapsed');
          });
        }
        div.classList.toggle('collapsed');
      };
    })(secDiv);
    secDiv.appendChild(heading);

    for (var i = 0; i < section.keys.length; i++) {

      var item = section.keys[i];

      // staffOnly entries (e.g. showHiddenPosts) are invisible to everyone
      // without a verified staff verdict in this browser — the same
      // staffNavRole signal staffModeEarly.js uses pre-paint.
      if (item.staffOnly && localStorage.getItem('staffNavRole') !== 'staff') {
        continue;
      }

      var div = document.createElement('div');
      div.className = 'settingRow';

      var label = document.createElement('label');
      var checkBox = document.createElement('input');

      checkBox.id = 'checkbox-' + item.key;
      checkBox.type = 'checkbox';
      checkBox.className = 'settingsCheckbox';
      checkBox.checked = settings.get(item.key);

      var nameSpan = document.createElement('span');
      nameSpan.className = 'settingName';
      nameSpan.textContent = settings.modes[item.key].text;

      label.appendChild(checkBox);
      label.appendChild(nameSpan);
      div.appendChild(label);

      if (item.desc) {
        var desc = document.createElement('div');
        desc.className = 'settingDesc';
        desc.textContent = item.desc;
        div.appendChild(desc);
      }

      secDiv.appendChild(div);
    }

    mainPanelSubContainer.appendChild(secDiv);
  }

  mainPanel.append(mainPanelSubContainer);

  var saveButton = document.createElement('button');
  mainPanel.appendChild(saveButton);
  saveButton.innerHTML = lang.save;
  saveButton.className = 'saveButton';

  saveButton.onclick = function() {
    for (var key in settings.modes) {
      settings.set(key, document.getElementById('checkbox-' + key).checked);
    }
    location.reload();
  };

  return mainPanel;

};

settingsMenu.init();
